// Mapping from MiniFileType to function_id for protocol chunk requests
// Update this mapping if protocol changes
import { MiniFileType } from './file_type';

// Response Function ID (for parsing received chunks)
// MINI protocol: 0x04=Datalog, 0x06=Eventlog, 0x08=Cal/Bump, 0x0A=Sensor config
export const MINI_FILE_TYPE_TO_FUNCTION_ID: Record<MiniFileType, number> = {
  [MiniFileType.DATALOG]: 0x04, // Response data log chunk
  [MiniFileType.EVENTLOG]: 0x06, // Response event(alarm) log chunk
  [MiniFileType.CAL_BUMP]: 0x08, // Response cal/bump log chunk
  [MiniFileType.SENSOR_CONFIG]: 0x0a, // Response sensor data chunk
};

// Request Function ID (for requesting individual chunks in Normal mode or retry)
// MINI protocol: 0x03=Datalog, 0x05=Eventlog, 0x07=Cal/Bump, 0x09=Sensor config
export const MINI_FILE_TYPE_TO_REQUEST_FUNCTION_ID: Record<MiniFileType, number> = {
  [MiniFileType.DATALOG]: 0x03, // Request data log chunk
  [MiniFileType.EVENTLOG]: 0x05, // Request event(alarm) log chunk
  [MiniFileType.CAL_BUMP]: 0x07, // Request cal/bump log chunk
  [MiniFileType.SENSOR_CONFIG]: 0x09, // Request sensor data chunk
};
